var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUserMini(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.16,
    height: 26.397,
    viewBox: "0 0 21.16 26.397",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_477",
    "data-name": "Group 477",
    transform: "translate(-58.115 -201.404)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_475",
    "data-name": "Group 475"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_474",
    "data-name": "Group 474"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_147",
    "data-name": "Ellipse 147",
    cx: 5.248,
    cy: 5.248,
    r: 5.248,
    transform: "translate(63.447 201.404)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_476",
    "data-name": "Group 476"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_493",
    "data-name": "Path 493",
    d: "M929.275,224.013A10.58,10.58,0,0,0,918.5,213.435a10.81,10.81,0,0,0-10.381,10.929v2.37a1.067,1.067,0,0,0,1.067,1.067h19.025a1.068,1.068,0,0,0,1.068-1.067Z",
    transform: "translate(-850)",
    fill: "#1a1a1a"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUserMini);
export default __webpack_public_path__ + "static/media/iconUserMini.354930bc9b4d2c289635af0edde66177.svg";
export { ForwardRef as ReactComponent };